const TRANSLATIONS = {
  es: {
    nav: {
      about: "Nosotros",
      services: "Servicios",
      jobs: "Bolsa de trabajo",
      blog: "Blog",
      contact: "Contacto",
      cta: "Agendar asesoría",
    },
    hero: {
      title: "Más que un proveedor de servicios;",
      highlight: "tu aliado estratégico para el crecimiento.",
      subtitle: "Ayudamos a personas y empresas a tomar mejores decisiones financieras con integridad y profesionalismo.",
      btn_services: "Nuestros servicios",
      btn_contact: "Contactar a un asesor",
      stat_years: "Años de experiencia",
      stat_offices: "Oficinas en México",
      stat_services: "Servicios especializados",
    },
    about: {
      eyebrow: "Conócenos",
      title: "¿Quiénes somos?",
      subtitle: "Red de Estudios Fiscales de México",
      quote: "Todo gran proyecto comienza con una idea clara: ayudar a las personas y empresas a tomar mejores decisiones financieras.",
      p1: "Nuestra firma REFMEX nació por la necesidad de compartir experiencias entre fiscalistas y abogados, actualmente todos socios ante el Instituto Mexicano Contadores Públicos, que avalan la capacidad técnica para el ejercicio de la profesión.",
      p2: "Desde nuestros inicios entendimos que la contaduría no solo consiste en cumplir obligaciones fiscales, sino en brindar tranquilidad a los empresarios aplicando un criterio prudencial.",
      p3: "Nuestros socios cuentan con experiencia de hasta 30 años, cada uno en su campo como especialista.",
      p4: "Creemos firmemente que una firma contable debe ser más que un proveedor de servicios; debe ser un aliado estratégico para el crecimiento de cada negocio.",
      feat_exp: "Experiencia",
      feat_exp_desc: "Hasta 30 años de experiencia",
      feat_team: "Equipo",
      feat_team_desc: "Socios del IMCP certificados",
      feat_presence: "Presencia",
      feat_presence_desc: "3 estados de México",
      feat_cert: "Certificación",
      feat_cert_desc: "Capacidad técnica avalada",
      card_title: "¿Qué hacemos?",
      card_desc: "Nos especializamos en auditoría, aseguramiento, consultoría, asesoría fiscal y servicios relacionados.",
      commitment_title: "Nuestro compromiso",
      commitment_p1: "Nuestro propósito es generar un impacto significativo en cada cliente y en cada proyecto en el que participamos. Creemos en el valor de la integridad, el servicio al interés público y la innovación como motores de crecimiento.",
      commitment_p2: "Colaboramos estrechamente con nuestros clientes para ayudarles a alcanzar sus objetivos, sin importar el tamaño de sus retos o aspiraciones. Nuestro enfoque se basa en acompañarlos con soluciones estratégicas, confianza y profesionalismo para construir juntos un futuro mejor.",
    },
    values: {
      eyebrow: "Ética y profesionalismo",
      title: "Valores que nos distinguen",
      ethics_title: "Ética profesional",
      ethics_intro: "Aplicamos a cabalidad los principios fundamentales establecidos en el código de ética profesional del contador independiente:",
      values_list: [
        { title: "Integridad", desc: "Actuar con honestidad, lealtad y veracidad en nuestras relaciones profesionales. Además, no asociarse con información falsa, confusa o presentada de manera descuidada. Si se relacionan con información de ese tipo, deben tomar medidas para desvincularse de ella." },
        { title: "Objetividad", desc: "Mantenemos en nuestro trabajo un juicio profesional imparcial, evitando prejuicios, conflictos de interés o influencias indebidas de terceros. Si alguna situación afecta a la objetividad, la firma no realiza el servicio profesional, para asegurar decisiones justas y confiables." },
        { title: "Diligencia y competencia", desc: "Realizar nuestro trabajo con cuidado, responsabilidad y conforme a las normas profesionales. Además, de mantenernos actualizados para ofrecer servicios competentes, aplicando siempre un juicio profesional adecuado." },
        { title: "Confidencialidad", desc: "Proteger la información obtenida de los usuarios. No deben revelarse información confidencial sin autorización, salvo cuando exista una obligación legal o profesional. Tampoco pueden utilizarse información para beneficio propio o de terceros." },
        { title: "Comportamiento profesional", desc: "Cumplir con las leyes, normas y reglamentos aplicables en el ejercicio de su profesión. Asimismo, deben evitar cualquier conducta o acción que pueda desacreditar o dañar la reputación de la profesión contable." },
      ],
      ethics_list: [
        { letter: "a", title: "Integridad", desc: "Ser leal, veraz y honrado en todas las relaciones profesionales y de negocios." },
        { letter: "b", title: "Objetividad", desc: "Evitar prejuicios, conflictos de interés o influencia indebida de terceros que afecten el juicio profesional o de negocios." },
        { letter: "c", title: "Diligencia y competencia profesionales", desc: "Mantener el conocimiento profesional y las habilidades al nivel necesario que aseguren que el cliente o la entidad para la que se trabaja reciben servicios profesionales competentes basados en los últimos avances de la práctica, la legislación y las técnicas, y actuar con diligencia y de conformidad con las normas técnicas y profesionales aplicables." },
        { letter: "d", title: "Confidencialidad", desc: "Respetar la confidencialidad de la información obtenida como resultado de relaciones profesionales o de negocios y, por lo tanto, no revelar dicha información a terceros sin la autorización apropiada y específica, a menos que haya un derecho u obligación legal o profesional de hacerlo, ni usar la información para provecho personal o de terceros." },
        { letter: "e", title: "Comportamiento profesional", desc: "Cumplir con las leyes y reglamentos relevantes, y evitar cualquier acción que desacredite a la profesión." },
      ],
    },
    services: {
      eyebrow: "Lo que hacemos",
      title: "Nuestros servicios",
      subtitle: "Servicios especializados en materia fiscal, contable y legal adaptados a tus necesidades",
      more: "Ver más",
      cta: "Contáctanos para una solución personalizada",
      hire: "Contratar servicio",
      req_fisicas: "Requisitos para personas físicas:",
      req_morales: "Requisitos para personas morales:",
      req_note: "Datos adicionales: Dos teléfonos y correos, relación de activos de la empresa, registros y/o certificaciones, entre otros.",
      services_list: [
        { title: "Auditoría", desc: "Revisión independiente de información financiera" },
        { title: "Contabilidad", desc: "Registro y control de operaciones financieras" },
        { title: "Impuestos", desc: "Cálculo, declaración y pago de contribuciones" },
        { title: "Registro REPSE", desc: "Tramitación y renovación del Registro" },
        { title: "Precios de transferencia", desc: "Estudios y documentación" },
        { title: "Acuerdos conclusivos", desc: "Representación ante el SAT" },
        { title: "Peritajes contables", desc: "Análisis forense y dictámenes" },
        { title: "Planeación estratégica", desc: "Consultoría fiscal y financiera" },
        { title: "Defensa penal-fiscal", desc: "Representación legal especializada" },
        { title: "Asesoría y consultoría", desc: "Acompañamiento profesional integral" },
        { title: "Compliance fiscal", desc: "Cumplimiento normativo tributario" },
        { title: "Compliance laboral", desc: "Verificación de obligaciones laborales" },
        { title: "Compliance corporativo", desc: "Cumplimiento normativo empresarial" },
      ],
    },
    jobs: {
      eyebrow: "Carreras",
      title: "Postúlate y trabaja en REFMEX",
      subtitle: "Forma parte de una red de profesionales comprometidos con la excelencia",
      positions_title: "Puestos disponibles",
      why_title: "¿Por qué trabajar con nosotros?",
      why: [
        "Ambiente de trabajo profesional y colaborativo",
        "Oportunidades de crecimiento y desarrollo",
        "Capacitación continua y actualización",
        "Proyectos desafiantes con clientes diversos",
      ],
      job_positions: [
        "Contador de Impuestos",
        "Contador de Costos",
        "Nominista",
        "Trámites (SAT-IMSS-INFONAVIT-STPS)",
        "Contador Fiscal",
        "Laboralista",
      ],
      form_title: "Formulario de postulación",
      name: "Nombre completo",
      age: "Edad",
      position: "Puesto al que se postula",
      position_placeholder: "Seleccionar puesto",
      degree: "Grado académico más alto",
      degree_placeholder: "Ej: Licenciatura en Contaduría",
      salary: "¿Cuánto desea ganar? (mensual)",
      salary_placeholder: "Ej: $25,000 MXN",
      cv: "Adjunta tu CV",
      submit: "Enviar postulación",
      submitting: "Enviando...",
      success: "¡Aplicación enviada exitosamente!",
      success_desc: "Nos pondremos en contacto contigo pronto.",
      error: "Error al enviar la aplicación",
      error_desc: "Por favor intenta de nuevo.",
    },
    blog: {
      eyebrow: "Recursos",
      title: "Blog",
      subtitle: "Contenido especializado para mantenerte informado",
      cta: "Consulta con un experto",
      tabs: {
        empresarios: "Para empresarios",
        fiscalistas: "Para fiscalistas",
        asalariados: "Para asalariados",
      },
    },
    contact: {
      eyebrow: "Contáctanos",
      title: "Estamos para atenderte",
      subtitle: "Agenda una cita o contáctanos directamente",
      advisor_title: "Hablar con un asesor",
      advisor_desc: "Selecciona el horario que mejor te convenga y agenda tu cita con nuestro equipo",
      advisor_btn: "Agendar asesoría",
      offices_title: "Nuestras oficinas",
      offices_hint: "Haz clic en cada marcador para ver los detalles",
      map_loading: "Cargando mapa...",
      whatsapp: "WhatsApp",
      see_map: "Ver mapa",
      calendly_title: "Agenda tu asesoría",
      calendly_instant: "¿Prefieres contacto inmediato?",
      calendly_wa: "WhatsApp 9612298120",
    },
    footer: {
      tagline: "Red de Estudios Fiscales de México. Tu aliado estratégico para el crecimiento empresarial.",
      follow: "Síguenos en Facebook",
      links_title: "Enlaces rápidos",
      links: [
        { label: "Nosotros", href: "#nosotros" },
        { label: "Servicios", href: "#servicios" },
        { label: "Bolsa de trabajo", href: "#bolsa-trabajo" },
        { label: "Blog", href: "#blog" },
        { label: "Contacto", href: "#contacto" },
      ],
      services_title: "Servicios destacados",
      contact_title: "Contacto",
      terms: "Términos de uso",
      privacy: "Declaración de privacidad",
      disclaimer: "Descargo de responsabilidad",
      legal: "El uso del contenido de este sitio es exclusivamente informativo y no constituye asesoría profesional. Consulte a un especialista para su caso particular.",
      admin: "Administración",
    },
  },

  en: {
    nav: {
      about: "About Us",
      services: "Services",
      jobs: "Job Board",
      blog: "Blog",
      contact: "Contact",
      cta: "Schedule Consultation",
    },
    hero: {
      title: "More than a service provider;",
      highlight: "your strategic partner for growth.",
      subtitle: "We help individuals and businesses make better financial decisions with integrity and professionalism.",
      btn_services: "Our Services",
      btn_contact: "Contact an Advisor",
      stat_years: "Years of Experience",
      stat_offices: "Offices in Mexico",
      stat_services: "Specialized Services",
    },
    about: {
      eyebrow: "About Us",
      title: "Who We Are",
      subtitle: "Red de Estudios Fiscales de México",
      quote: "Every great project starts with a clear idea: helping people and businesses make better financial decisions.",
      p1: "REFMEX was born from the need to share expertise among tax specialists and lawyers, all of whom are members of the Instituto Mexicano de Contadores Públicos, validating our technical capacity.",
      p2: "From the beginning, we understood that accounting is not just about meeting tax obligations, but about giving business owners peace of mind through sound professional judgment.",
      p3: "Our partners have up to 30 years of experience, each a specialist in their field.",
      p4: "We firmly believe that an accounting firm should be more than a service provider — it should be a strategic partner for the growth of every business.",
      feat_exp: "Experience",
      feat_exp_desc: "Up to 30 years of experience",
      feat_team: "Team",
      feat_team_desc: "IMCP certified partners",
      feat_presence: "Presence",
      feat_presence_desc: "3 states across Mexico",
      feat_cert: "Certification",
      feat_cert_desc: "Validated technical capacity",
      card_title: "What we do",
      card_desc: "We specialize in auditing, assurance, consulting, tax advisory and related services.",
      commitment_title: "Our Commitment",
      commitment_p1: "Our purpose is to generate a significant impact on every client and project we participate in. We believe in integrity, public interest service, and innovation as growth drivers.",
      commitment_p2: "We work closely with our clients to help them achieve their goals, regardless of the size of their challenges. Our approach is based on strategic solutions, trust, and professionalism.",
    },
    values: {
      eyebrow: "Ethics & Professionalism",
      title: "Values that define us",
      ethics_title: "Professional Ethics",
      ethics_intro: "We fully apply the fundamental principles established in the professional ethics code for independent accountants:",
      values_list: [
        { title: "Integrity", desc: "Act with honesty, loyalty and truthfulness in our professional relationships. We do not associate with false, misleading or carelessly presented information. If related to such information, we take steps to distance ourselves from it." },
        { title: "Objectivity", desc: "We maintain impartial professional judgment in our work, avoiding bias, conflicts of interest or undue influence from third parties. If any situation affects objectivity, the firm declines the engagement to ensure fair and reliable decisions." },
        { title: "Diligence & Competence", desc: "Perform our work carefully, responsibly and in accordance with professional standards. We stay up to date to deliver competent services, always applying sound professional judgment." },
        { title: "Confidentiality", desc: "Protect information obtained from clients. Confidential information must not be disclosed without authorization, except when a legal or professional obligation exists. Such information may not be used for personal or third-party benefit." },
        { title: "Professional Conduct", desc: "Comply with the laws, standards and regulations applicable to the profession. Avoid any conduct or action that could discredit or damage the reputation of the accounting profession." },
      ],
      ethics_list: [
        { letter: "a", title: "Integrity", desc: "Be loyal, truthful and honest in all professional and business relationships." },
        { letter: "b", title: "Objectivity", desc: "Avoid bias, conflicts of interest or undue third-party influence that could affect professional or business judgment." },
        { letter: "c", title: "Professional competence and due care", desc: "Maintain professional knowledge and skills at the level required to ensure clients or employing entities receive competent professional services based on current practice, legislation and techniques, and act diligently in accordance with applicable technical and professional standards." },
        { letter: "d", title: "Confidentiality", desc: "Respect the confidentiality of information obtained as a result of professional or business relationships, and therefore not disclose any such information to third parties without proper and specific authority, unless there is a legal or professional right or duty to disclose, nor use it for personal advantage or the advantage of third parties." },
        { letter: "e", title: "Professional behavior", desc: "Comply with relevant laws and regulations and avoid any action that discredits the profession." },
      ],
    },
    services: {
      eyebrow: "What we do",
      title: "Our services",
      subtitle: "Specialized services in tax, accounting and legal matters tailored to your needs",
      more: "Learn more",
      cta: "Contact Us for a Custom Solution",
      hire: "Hire Service",
      req_fisicas: "Requirements for Individuals:",
      req_morales: "Requirements for Legal Entities:",
      req_note: "Additional information: Two phone numbers and emails, company asset list, registrations and/or certifications, among others.",
      services_list: [
        { title: "Audit", desc: "Independent review of financial information" },
        { title: "Accounting", desc: "Recording and control of financial operations" },
        { title: "Tax", desc: "Calculation, filing and payment of contributions" },
        { title: "REPSE Registration", desc: "Application and renewal of the Registry" },
        { title: "Transfer Pricing", desc: "Studies and documentation" },
        { title: "Conclusive Agreements", desc: "Representation before SAT" },
        { title: "Accounting Expert Reports", desc: "Forensic analysis and opinions" },
        { title: "Strategic Planning", desc: "Tax and financial consulting" },
        { title: "Criminal Tax Defense", desc: "Specialized legal representation" },
        { title: "Advisory & Consulting", desc: "Comprehensive professional support" },
        { title: "Tax Compliance", desc: "Tax regulatory compliance" },
        { title: "Labor Compliance", desc: "Verification of labor obligations" },
        { title: "Corporate Compliance", desc: "Corporate regulatory compliance" },
      ],
    },
    jobs: {
      eyebrow: "Careers",
      title: "Join the REFMEX Team",
      subtitle: "Be part of a network of professionals committed to excellence",
      positions_title: "Open Positions",
      why_title: "Why work with us?",
      why: [
        "Professional and collaborative work environment",
        "Growth and development opportunities",
        "Continuous training and updates",
        "Challenging projects with diverse clients",
      ],
      job_positions: [
        "Tax Accountant",
        "Cost Accountant",
        "Payroll Specialist",
        "Filings (SAT-IMSS-INFONAVIT-STPS)",
        "Tax Advisor",
        "Labor Law Specialist",
      ],
      form_title: "Application Form",
      name: "Full Name",
      age: "Age",
      position: "Position Applying For",
      position_placeholder: "Select position",
      degree: "Highest Academic Degree",
      degree_placeholder: "e.g. Bachelor's in Accounting",
      salary: "Desired Monthly Salary",
      salary_placeholder: "e.g. $25,000 MXN",
      cv: "Attach your CV",
      submit: "Submit Application",
      submitting: "Sending...",
      success: "Application sent successfully!",
      success_desc: "We will get in touch with you soon.",
      error: "Error sending application",
      error_desc: "Please try again.",
    },
    blog: {
      eyebrow: "Resources",
      title: "Blog",
      subtitle: "Specialized content to keep you informed",
      cta: "Consult with an Expert",
      tabs: {
        empresarios: "For Business Owners",
        fiscalistas: "For Tax Specialists",
        asalariados: "For Employees",
      },
    },
    contact: {
      eyebrow: "Contact Us",
      title: "We Are Here for You",
      subtitle: "Schedule an appointment or contact us directly",
      advisor_title: "Talk to an Advisor",
      advisor_desc: "Select the time that works best for you and schedule your appointment with our team",
      advisor_btn: "Schedule Consultation",
      offices_title: "Our Offices",
      offices_hint: "Click each marker to see details",
      map_loading: "Loading map...",
      whatsapp: "WhatsApp",
      see_map: "View map",
      calendly_title: "Schedule Your Consultation",
      calendly_instant: "Prefer immediate contact?",
      calendly_wa: "WhatsApp 9612298120",
    },
    footer: {
      tagline: "Red de Estudios Fiscales de México. Your strategic partner for business growth.",
      follow: "Follow us on Facebook",
      links_title: "Quick Links",
      links: [
        { label: "About Us", href: "#nosotros" },
        { label: "Services", href: "#servicios" },
        { label: "Job Board", href: "#bolsa-trabajo" },
        { label: "Blog", href: "#blog" },
        { label: "Contact", href: "#contacto" },
      ],
      services_title: "Featured Services",
      contact_title: "Contact",
      terms: "Terms of Use",
      privacy: "Privacy Statement",
      disclaimer: "Disclaimer",
      legal: "The content of this site is for informational purposes only and does not constitute professional advice. Please consult a specialist for your specific case.",
      admin: "Administration",
    },
  },
};

export default TRANSLATIONS;
